/**
 * @licence
 * Copyright 2021 ModBros OG
 * Licenced under apache Licence, Version 2.0
 */

/**
 * Do not edit directly!
 * Generated on Wed Oct 13 2021 19:02:58 GMT+0200 (Central European Summer Time)
 */

export const BoxShadow = {
  None: 'var(--modbros-box-shadow-none, none)',
  '8Pt': 'var(--modbros-box-shadow-8-pt, 0px 8px 10px rgba(2, 3, 3, 0.03), 0px 3px 14px rgba(2, 3, 3, 0.02), 0px 5px 5px rgba(2, 3, 3, 0.04))',
  '16Pt': 'var(--modbros-box-shadow-16-pt, 0px 16px 24px rgba(2, 3, 3, 0.03), 0px 6px 30px rgba(2, 3, 3, 0.02), 0px 8px 10px rgba(2, 3, 3, 0.04))',
  '48Pt': 'var(--modbros-box-shadow-48-pt, 0px 54px 82px rgba(2, 3, 3, 0.03), 0px 22px 98px rgba(2, 3, 3, 0.02), 0px 23px 28px rgba(2, 3, 3, 0.04))'
};
export default {
  BoxShadow,
}